import PropTypes from 'prop-types';
import WishListAdmin from './WishListAdmin';
import LoginForm from './LoginForm';
import SignUp from './SignUp';

const { isAuthenticated } = sandals_app.page;

export default class LoginPanel extends React.Component {
    static propTypes = {
        countries: PropTypes.array,
        isAddItem: PropTypes.bool,
        itemDetails: PropTypes.object,
        isSuccessAddedHandler: PropTypes.func,
        updateAccountInfo: PropTypes.func,
        modalUpdateHandler: PropTypes.func,
        getModifiedWishList: PropTypes.func,
        isSignUp: PropTypes.bool,
        hasCreateWishlist: PropTypes.bool,
        fromWishlistCollage: PropTypes.bool,
        userWishlists: PropTypes.array,
        shouldLogIn: PropTypes.bool
    };
    static defaultProps = {
        isAddItem: false,
        isSignUp: false,
        countries: [],
        itemDetails: {},
        updateAccountInfo: () => null,
        modalUpdateHandler: () => null,
        isSuccessAddedHandler: () => null,
        getModifiedWishList: () => null,
        hasCreateWishlist: true,
        fromWishlistCollage: false,
        userWishlists: [],
        shouldLogIn: true
    };

    static getDerivedStateFromProps(newProps, state) {
        const isSignUpChanged = (state.isSignUp !== newProps.isSignUp);

        if (isSignUpChanged) {

            return {
                ...newProps
            };
        }

        return null;
    }
    constructor() {
        super();
        this.state = {
            isAuthenticated: isAuthenticated,
            isSignUp: false
        };
    }
    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
        if (this.props.isSignUp !== prevProps.isSignUp) {
            // console.log('login panel was updated');
        }
    }

    _handlerAfterLogIn = (isLoggedIn = true) => {
        this.setState({isAuthenticated: isLoggedIn});
    };
    _handlerIsSignUp = (isSignUp = false) => {
        this.setState({isSignUp});
    };

    render() {
        const { isAddItem, countries, itemDetails, isSuccessAddedHandler, updateAccountInfo, modalUpdateHandler, getModifiedWishList, hasCreateWishlist, fromWishlistCollage, userWishlists, shouldLogIn } = this.props;

        let currentComponent;

        if (this.state.isSignUp && !this.state.isAuthenticated) {
            currentComponent = <SignUp countries={countries} handlerIsSignUp={this._handlerIsSignUp} itemDetails={itemDetails} isSuccessAddedHandler={isSuccessAddedHandler} handlerAfterLogIn={this._handlerAfterLogIn} modalUpdateHandler={modalUpdateHandler} getModifiedWishList={getModifiedWishList}/>;
        } else if (this.state.isAuthenticated) {
            currentComponent = <WishListAdmin isAddItem={isAddItem} itemDetails={itemDetails} isSuccessAddedHandler={isSuccessAddedHandler} updateAccountInfo={updateAccountInfo} modalUpdateHandler={modalUpdateHandler} getModifiedWishList={getModifiedWishList} hasCreateWishlist={hasCreateWishlist} fromWishlistCollage={ fromWishlistCollage } userWishlists={ userWishlists } shouldLogIn = { shouldLogIn } />;
        } else if(!this.state.isAuthenticated || !this.state.isSignUp) {
            currentComponent = <LoginForm countries={countries} handlerAfterLogIn={this._handlerAfterLogIn} isAddItem={isAddItem} handlerIsSignUp={this._handlerIsSignUp}/>;
        }

        return(
            <div className="dashboard-wrapper">
                { currentComponent }
            </div>
        );
    }
}
